// extracted by mini-css-extract-plugin
export default {"table":"style--table--f159b8","fixed":"style--fixed--bab3f1","auto":"style--auto--10b249","border":"style--border--494f1a"};